export const API_URL = process.env.REACT_APP_API_URL;
export const WS_URL = process.env.REACT_APP_WS_URL;

export const GITHUB_LINK = process.env.REACT_APP_GITHUB_LINK;
export const TWITTER_LINK = process.env.REACT_APP_TWITTER_LINK;
